import {
  ADD_ORDER_PART_FAIL,
  ADD_ORDER_PART_REQUEST,
  ADD_ORDER_PART_SUCCESS,
  DELETE_ORDER_PART_FAIL,
  DELETE_ORDER_PART_REQUEST,
  DELETE_ORDER_PART_SUCCESS,
  EDIT_ORDER_PART_MANUAL_STEP_FAIL,
  EDIT_ORDER_PART_MANUAL_STEP_REQUEST,
  EDIT_ORDER_PART_MANUAL_STEP_SUCCESS,
  EDIT_ORDER_PART_STEP_FAIL,
  EDIT_ORDER_PART_STEP_REQUEST,
  EDIT_ORDER_PART_STEP_SUCCESS,
  GET_ORDER_PART_LIST_FAIL,
  GET_ORDER_PART_LIST_REQUEST,
  GET_ORDER_PART_LIST_SUCCESS,
  GET_ORDER_PART_LOG_FAIL,
  GET_ORDER_PART_LOG_REQUEST,
  GET_ORDER_PART_LOG_SUCCESS,
  GET_ORDER_PART_MANUAL_STEP_LIST_FAIL,
  GET_ORDER_PART_MANUAL_STEP_LIST_REQUEST,
  GET_ORDER_PART_MANUAL_STEP_LIST_SUCCESS,
  GET_ORDER_PART_STEP_LIST_FAIL,
  GET_ORDER_PART_STEP_LIST_REQUEST,
  GET_ORDER_PART_STEP_LIST_SUCCESS,
  GET_SINGLE_ORDER_PART_FAIL,
  GET_SINGLE_ORDER_PART_REQUEST,
  GET_SINGLE_ORDER_PART_SUCCESS,
  UPDATE_ORDER_PART_FAIL,
  UPDATE_ORDER_PART_REQUEST,
  UPDATE_ORDER_PART_SUCCESS,
} from "src/constants/types";

export const orderPartReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_ORDER_PART_STEP_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_ORDER_PART_STEP_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        orderPartStepList: actions.payload,
        error: "",
      };
    case GET_ORDER_PART_STEP_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_ORDER_PART_MANUAL_STEP_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_ORDER_PART_MANUAL_STEP_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        orderPartManualStepList: actions.payload,
        error: "",
      };
    case GET_ORDER_PART_MANUAL_STEP_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_ORDER_PART_LOG_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_ORDER_PART_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        orderPartLog: actions.payload,
        error: "",
      };
    case GET_ORDER_PART_LOG_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_ORDER_PART_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_ORDER_PART_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        orderParts: actions.payload,
        error: "",
      };
    case GET_ORDER_PART_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_ORDER_PART_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_ORDER_PART_SUCCESS:
      return {
        ...state,
        loading: false,
        orderPart: actions.payload,
      };
    case GET_SINGLE_ORDER_PART_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_ORDER_PART_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case ADD_ORDER_PART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case ADD_ORDER_PART_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case EDIT_ORDER_PART_STEP_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case EDIT_ORDER_PART_STEP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case EDIT_ORDER_PART_STEP_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case EDIT_ORDER_PART_MANUAL_STEP_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case EDIT_ORDER_PART_MANUAL_STEP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case EDIT_ORDER_PART_MANUAL_STEP_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_ORDER_PART_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case UPDATE_ORDER_PART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case UPDATE_ORDER_PART_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_ORDER_PART_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case DELETE_ORDER_PART_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };

    case DELETE_ORDER_PART_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
